import React, { useState } from 'react';
import './modelphotoshoot.css';

const modelProfiles = [
  {
    id: 'm1',
    name: 'Sora Choi',
    agency: 'Elite Paris',
    height: "5'10\"",
    bust: '31"',
    waist: '23"',
    hips: '34"',
    category: 'Runway',
    coverImage: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=900&q=80',
    recentCampaign: 'Vogue Korea Spring Cover',
  },
  {
    id: 'm2',
    name: 'Mikael Sundqvist',
    agency: 'Ford Models NYC',
    height: "6'2\"",
    bust: '38"',
    waist: '30"',
    hips: '36"',
    category: 'Commercial',
    coverImage: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=900&q=80',
    recentCampaign: 'Acne Studios Fall/Winter',
  },
  {
    id: 'm3',
    name: 'Anok Deng',
    agency: 'IMG London',
    height: "5'11\"",
    bust: '32"',
    waist: '24"',
    hips: '35"',
    category: 'Editorial',
    coverImage: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?auto=format&fit=crop&w=900&q=80',
    recentCampaign: 'Harper’s Bazaar Digital',
  },
  {
    id: 'm4',
    name: 'Kai Laurent',
    agency: 'Success Homme Paris',
    height: "6'1\"",
    bust: '37"',
    waist: '29"',
    hips: '35"',
    category: 'Runway',
    coverImage: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=900&q=80',
    recentCampaign: 'Jacquemus Summer Presentation',
  },
];

const categories = ['All', 'Editorial', 'Runway', 'Commercial'];

function Modelphotoshoot() {
  const [selectedFilter, setSelectedFilter] = useState('All');

  const filteredModels = selectedFilter === 'All'
    ? modelProfiles
    : modelProfiles.filter((profile) => profile.category === selectedFilter);

  return (
    <section className="mps-container">
      {/* Top Bar */}
      <div className="mps-hero">
        <div className="mps-hero__text">
          <span className="mps-hero__badge">Casting & Talent</span>
          <h1 className="mps-hero__heading">Model Roster</h1>
        </div>
        <p className="mps-hero__summary">
          Direct booking representation, polaroids, and measurements for global editorial campaigns.
        </p>
      </div>

      {/* Roster Controls */}
      <div className="mps-controls">
        <span className="mps-controls__count">
          Showing {filteredModels.length} {filteredModels.length === 1 ? 'Profile' : 'Profiles'}
        </span>
        <div className="mps-controls__filters">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setSelectedFilter(cat)}
              className={`mps-filter-btn ${selectedFilter === cat ? 'mps-filter-btn--active' : ''}`}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* Model Profiles Grid */}
      <div className="mps-board">
        {filteredModels.map((model) => (
          <article key={model.id} className="mps-card">
            <div className="mps-card__frame">
              <img
                src={model.coverImage}
                alt={model.name}
                className="mps-card__photo"
                loading="lazy"
              />
              <span className="mps-card__tag">{model.category}</span>
            </div>

            <div className="mps-card__content">
              <div className="mps-card__header">
                <h2 className="mps-card__name">{model.name}</h2>
                <span className="mps-card__agency">{model.agency}</span>
              </div>

              {/* Measurements Row */}
              <div className="mps-card__stats">
                <div className="mps-stat">
                  <span className="mps-stat__label">Height</span>
                  <span className="mps-stat__value">{model.height}</span>
                </div>
                <div className="mps-stat">
                  <span className="mps-stat__label">Bust</span>
                  <span className="mps-stat__value">{model.bust}</span>
                </div>
                <div className="mps-stat">
                  <span className="mps-stat__label">Waist</span>
                  <span className="mps-stat__value">{model.waist}</span>
                </div>
                <div className="mps-stat">
                  <span className="mps-stat__label">Hips</span>
                  <span className="mps-stat__value">{model.hips}</span>
                </div>
              </div>

              <div className="mps-card__campaign">
                <span className="mps-campaign-label">Recent:</span>
                <span className="mps-campaign-name">{model.recentCampaign}</span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Modelphotoshoot;